
import './pl_landlord.css';

var RADIO_ON = '/assets/img/landlord/icon-formula-radio-on.png';
var RADIO_OFF = '/assets/img/landlord/icon-formula-radio-off.png';
var VAR_LABELS = {
  guest_count: '人数',
  nights: '日数',
  income: '収入額',
  stay_tax: '宿泊税',
  A: 'A総売上',
  B: 'Bサイト手数料',
  C: 'C弊社報酬',
  D: 'D清掃費',
  E: 'Eアメニティ',
  F: 'F消耗品',
  G: 'Gクリーニング',
  H: 'Hウエルカムシャンパン'
};
var BASE_VARS = [
  '人数',
  '日数',
  '収入額',
  '宿泊税',
  'A総売上',
  'Bサイト手数料',
  'C弊社報酬',
  'D清掃費',
  'Eアメニティ',
  'F消耗品',
  'Gクリーニング',
  'Hウエルカムシャンパン'
];

export default {
  name: 'formula-edit',
  props: {
    value: { type: Boolean, default: false },
    costName: { type: String, default: 'F消耗品' },
    remark: { type: String, default: '' },
    formula: { type: String, default: '1000 × 人数 × 日数' },
    formulaAst: { type: [Object, Array], default: null },
    columns: { type: Array, default: function () { return []; } }
  },
  data: function () {
    return {
      localName: 'F消耗品',
      localRemark: '',
      localFormula: '',
      terms: [{ mode: 'number', value: '' }],
      ops: [],
      opMenu: -1,
      varMenu: -1,
      menuPos: { top: 0, left: 0 },
      radioOn: RADIO_ON,
      radioOff: RADIO_OFF,
      opChoices: ['+', '-', '*', '/']
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    varChoices: function () {
      var seen = {};
      var list = BASE_VARS.slice();
      var i;
      for (i = 0; i < list.length; i++) seen[list[i]] = true;
      var extra = this.columns || [];
      for (i = 0; i < extra.length; i++) {
        var label = extra[i];
        if (!label || seen[label]) continue;
        seen[label] = true;
        list.push(label);
      }
      return list;
    },
    menuStyle: function () {
      var pos = this.menuPos || { top: 0, left: 0 };
      return {
        top: pos.top + 'px',
        left: pos.left + 'px'
      };
    }
  },
  watch: {
    value: function (opened) {
      if (!opened) {
        this.closeMenus();
        return;
      }
      this.localName = this.costName == null ? 'F消耗品' : this.costName;
      this.localRemark = this.remark || '';
      this.loadTerms();
    }
  },
  methods: {
    close: function () {
      this.closeMenus();
      this.$emit('input', false);
    },
    closeMenus: function () {
      this.opMenu = -1;
      this.varMenu = -1;
    },
    clipRemark: function (raw) {
      var s = raw == null ? '' : String(raw);
      if (s.length > 12) s = s.slice(0, 12);
      return s;
    },
    opText: function (op) {
      if (op === '*') return '×';
      if (op === '/') return '÷';
      if (op === '-') return '−';
      return '＋';
    },
    placeMenu: function (el, kind) {
      var rect = el.getBoundingClientRect();
      var width = kind === 'var' ? 160 : 42;
      var height = kind === 'var' ? 238 : 168;
      var left = rect.left + (rect.width - width) / 2;
      var gap = 4;
      var below = rect.bottom + gap;
      var above = rect.top - gap - height;
      var top = below;
      if (below + height > window.innerHeight - 8 && above >= 8) top = above;
      if (left < 8) left = 8;
      if (left + width > window.innerWidth - 8) left = window.innerWidth - 8 - width;
      this.menuPos = { top: top, left: left };
    },
    toggleOp: function (index, ev) {
      if (this.opMenu === index) {
        this.opMenu = -1;
        return;
      }
      this.varMenu = -1;
      this.opMenu = index;
      this.placeMenu(ev.currentTarget, 'op');
    },
    setOp: function (index, op) {
      this.$set(this.ops, index - 1, op);
      this.opMenu = -1;
      this.syncFormula();
    },
    toggleVar: function (index, ev) {
      if (this.varMenu === index) {
        this.varMenu = -1;
        return;
      }
      this.opMenu = -1;
      this.varMenu = index;
      this.placeMenu(ev.currentTarget, 'var');
    },
    pickVar: function (index, label) {
      var term = this.terms[index];
      if (!term || !label) return;
      term.mode = 'var';
      term.value = label;
      this.varMenu = -1;
      this.syncFormula();
    },
    setMode: function (index, mode) {
      var term = this.terms[index];
      if (!term || term.mode === mode) return;
      term.mode = mode;
      if (mode === 'number' && !this.isInsertNumber(term.value)) term.value = '';
      if (mode === 'var' && !this.mapIdent(String(term.value || '').trim())) term.value = '';
      this.closeMenus();
      this.syncFormula();
    },
    addTerm: function () {
      this.terms.push({ mode: 'number', value: '' });
      this.ops.push('+');
      this.closeMenus();
      this.syncFormula();
    },
    removeTerm: function (index) {
      if (this.terms.length <= 1) {
        this.terms[0].value = '';
        this.syncFormula();
        return;
      }
      this.terms.splice(index, 1);
      if (index === 0) this.ops.splice(0, 1);
      else this.ops.splice(index - 1, 1);
      this.closeMenus();
      this.syncFormula();
    },
    removeLast: function () {
      this.removeTerm(this.terms.length - 1);
    },
    resetTerms: function () {
      this.terms = [{ mode: 'number', value: '' }];
      this.ops = [];
      this.closeMenus();
      this.localFormula = '';
    },
    isInsertNumber: function (s) {
      if (s == null || s === '') return false;
      return isFinite(Number(s));
    },
    syncFormula: function () {
      this.localFormula = this.formulaFromTerms();
    },
    formulaFromTerms: function () {
      var s = '';
      var i;
      for (i = 0; i < this.terms.length; i++) {
        var term = this.terms[i];
        var text = term && term.value != null ? String(term.value).trim() : '';
        if (i > 0) {
          var op = this.ops[i - 1] || '+';
          s += op === '*' ? ' × ' : (' ' + op + ' ');
        }
        s += text;
      }
      return s.trim();
    },
    loadTerms: function () {
      var src = '';
      if (this.hasAst(this.formulaAst)) src = this.printAst(this.formulaAst);
      else src = this.formula || '';
      var tokens = this.tokenize(src);
      var terms = [];
      var ops = [];
      var i;
      if (tokens) {
        for (i = 0; i < tokens.length; i++) {
          var tok = tokens[i];
          if (tok.type === 'op') {
            ops.push(tok.op);
            continue;
          }
          var node = tok.node || {};
          if (node.op === 'const') terms.push({ mode: 'number', value: String(node.value) });
          else if (node.op === 'var') terms.push({ mode: 'var', value: this.printVar(node.name) });
        }
      }
      if (!terms.length) terms.push({ mode: 'number', value: '' });
      while (ops.length > terms.length - 1) ops.pop();
      while (ops.length < terms.length - 1) ops.push('+');
      this.terms = terms;
      this.ops = ops;
      this.closeMenus();
      this.localFormula = this.formulaFromTerms();
    },
    hasAst: function (node) {
      if (!node) return false;
      if (typeof node === 'string') {
        try {
          node = JSON.parse(node);
        } catch (e) {
          return false;
        }
      }
      return !!(node && typeof node === 'object' && node.op);
    },
    printVar: function (name) {
      if (VAR_LABELS[name]) return VAR_LABELS[name];
      return name || '';
    },
    printAst: function (node) {
      if (typeof node === 'string') {
        try {
          node = JSON.parse(node);
        } catch (e) {
          return '';
        }
      }
      if (!node || typeof node !== 'object') return '';
      var op = node.op;
      if (op === 'const') return String(node.value);
      if (op === 'var') return this.printVar(node.name);
      var args = node.args || [];
      var parts = [];
      for (var i = 0; i < args.length; i++) parts.push(this.printAst(args[i]));
      var sep = op === '*' ? ' × ' : (' ' + op + ' ');
      return parts.join(sep);
    },
    mapIdent: function (ident) {
      var map = {
        '人数': 'guest_count',
        '日数': 'nights',
        '収入額': 'income',
        '収入': 'income',
        '宿泊税': 'stay_tax',
        'guest_count': 'guest_count',
        'nights': 'nights',
        'income': 'income',
        'stay_tax': 'stay_tax',
        'A総売上': 'A',
        'Bサイト手数料': 'B',
        'C弊社報酬': 'C',
        'D清掃費': 'D',
        'Eアメニティ': 'E',
        'F消耗品': 'F',
        'Gクリーニング': 'G',
        'Hウエルカムシャンパン': 'H'
      };
      if (map[ident]) return { op: 'var', name: map[ident] };
      if (/^[A-H]$/.test(ident)) return { op: 'var', name: ident };
      if (/^[A-H]/.test(ident)) return { op: 'var', name: ident.charAt(0) };
      return null;
    },
    tokenize: function (src) {
      var out = [];
      var i = 0;
      src = String(src || '');
      while (i < src.length) {
        var c = src.charAt(i);
        if (c === ' ' || c === '\t' || c === '\n') {
          i++;
          continue;
        }
        if (c === '＋') c = '+';
        if (c === '−' || c === '－') c = '-';
        if (c === '÷') c = '/';
        if (c === '-') {
          var next = i + 1 < src.length ? src.charAt(i + 1) : '';
          var isNum = (next >= '0' && next <= '9') || next === '.';
          var unary = out.length === 0 || (out[out.length - 1] && out[out.length - 1].type === 'op');
          if (isNum && unary) {
            var j = i + 1;
            while (j < src.length && ((src.charAt(j) >= '0' && src.charAt(j) <= '9') || src.charAt(j) === '.')) j++;
            var signed = Number(src.slice(i, j));
            if (!isFinite(signed)) return null;
            out.push({ type: 'node', node: { op: 'const', value: signed } });
            i = j;
            continue;
          }
        }
        if (c === '×' || c === '*' || c === '+' || c === '-' || c === '/') {
          out.push({ type: 'op', op: c === '×' ? '*' : c });
          i++;
          continue;
        }
        if ((c >= '0' && c <= '9') || c === '.') {
          var k = i;
          while (k < src.length && ((src.charAt(k) >= '0' && src.charAt(k) <= '9') || src.charAt(k) === '.')) k++;
          var num = Number(src.slice(i, k));
          if (!isFinite(num)) return null;
          out.push({ type: 'node', node: { op: 'const', value: num } });
          i = k;
          continue;
        }
        var n = i;
        while (n < src.length) {
          var ch = src.charAt(n);
          if (ch === ' ' || ch === '×' || ch === '*' || ch === '+' || ch === '-' || ch === '/' || ch === '＋' || ch === '−' || ch === '－' || ch === '÷') break;
          n++;
        }
        if (n === i) return null;
        var mapped = this.mapIdent(src.slice(i, n));
        if (!mapped) return null;
        out.push({ type: 'node', node: mapped });
        i = n;
      }
      return out;
    },
    parseMul: function (tokens, idx) {
      if (idx.i >= tokens.length || tokens[idx.i].type !== 'node') return null;
      var args = [tokens[idx.i].node];
      var op = null;
      idx.i++;
      while (idx.i < tokens.length && tokens[idx.i].type === 'op' && (tokens[idx.i].op === '*' || tokens[idx.i].op === '/')) {
        var thisOp = tokens[idx.i].op;
        idx.i++;
        if (idx.i >= tokens.length || tokens[idx.i].type !== 'node') return null;
        if (op && thisOp !== op) {
          args = [{ op: op, args: args }, tokens[idx.i].node];
          op = thisOp;
        } else {
          op = thisOp;
          args.push(tokens[idx.i].node);
        }
        idx.i++;
      }
      if (!op) return args[0];
      return args.length === 1 ? args[0] : { op: op, args: args };
    },
    parseAdd: function (tokens, idx) {
      var node = this.parseMul(tokens, idx);
      if (!node) return null;
      var args = [node];
      var op = null;
      while (idx.i < tokens.length && tokens[idx.i].type === 'op' && (tokens[idx.i].op === '+' || tokens[idx.i].op === '-')) {
        var thisOp = tokens[idx.i].op;
        idx.i++;
        var rhs = this.parseMul(tokens, idx);
        if (!rhs) return null;
        if (op && thisOp !== op) {
          args = [{ op: op, args: args }, rhs];
          op = thisOp;
        } else {
          op = thisOp;
          args.push(rhs);
        }
      }
      if (!op) return node;
      return args.length === 1 ? args[0] : { op: op, args: args };
    },
    parseFormula: function (text) {
      var src = String(text || '').trim();
      if (!src) return null;
      var tokens = this.tokenize(src);
      if (!tokens || !tokens.length) return null;
      var idx = { i: 0 };
      var ast = this.parseAdd(tokens, idx);
      if (!ast || idx.i !== tokens.length) return null;
      return ast;
    },
    onOk: function () {
      this.syncFormula();
      var name = String(this.localName || '').replace(/^\s+|\s+$/g, '');
      var ast = this.parseFormula(this.localFormula);
      this.$emit('confirm', {
        costName: name,
        remark: this.clipRemark(this.localRemark),
        formula: this.localFormula,
        ast: ast
      });
      if (ast && name) this.close();
    },
    onCancel: function () {
      this.close();
    }
  }
};
